export const FETCH_ALLFEES_COLLECTION_REQUEST = 'FETCH_ALLFEES_COLLECTION_REQUEST'
export const FETCH_ALLFEES_COLLECTION_SUCCESS = 'FETCH_ALLFEES_COLLECTION_SUCCESS'
export const FETCH_ALLFEES_COLLECTION_FALIURE = 'FETCH_ALLFEES_COLLECTION_FALIURE'
